<template>
  <div class="px-3 main-wrapper">
    <div>
      <div class="mt-3">
        <h3 class="mb-0 text-white text-center !text-[22px] !font-semibold">
          {{ $t("deposit.deposit_form") }}
        </h3>
      </div>
      <div
        class="error text-center py-2"
        v-if="error"
      >
        <span class="mx-auto">
          {{ error }}
        </span>
      </div>

      <div class="card-body bg-transparent">
        <form>
          <!-- <h6 class="heading-small" style="color: #000 !important;">
                          {{
                              $store.state.language === "en"
                                  ? "Account information"
                                  : "အကောင့်ဆိုင်ရာ အချက်အလက်များ"
                          }}
                      </h6>
                      <span class="heading-small">{{
                                  $store.state.language === "en"
                                      ? "User's Balance"
                                      : "လက်ကျန်ငွေ"
                              }} - </span>
                      <span>
                        <b class="text-dark">{{ Number($store.state.amount).toLocaleString() }}</b>
                        {{ $store.state.language === 'en' ? '฿' : 'ကျပ်' }}
                      </span> -->
          <div class="mt-3">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="form-control-label"
                    for="input-username"
                    style="
                      color: #fff !important;
                      font-size: 1rem;
                      font-weight: 400 !important;
                    "
                  >{{ $t("deposit.choose_payment_type") }}</label>
                  <!-- <v-select
                    :options="accounts"
                    label="name"
                    v-model="selected_account.account_id"
                    :reduce="(account) => account.id"
                  >
                    <template v-slot:option="option">
                      <img
                        :src="option.link"
                        style="width: 25px;"
                      />
                      <span class="text-capitalize mr-4">&nbsp;&nbsp;{{ option.name }}</span>
                    </template>
</v-select> -->
                  <input
                    type="text"
                    readonly
                    placeholder="Banks"
                    @click="showPicker = true"
                    :value="accounts.find(
                      (acc) => acc.id === selected_account.account_id
                    )?.name
                      "
                    class="bg-transparent text-white border-0 cursor-pointer !border-b-[1px] w-full py-3 !border-white rounded-0"
                  />

                  <popup
                    v-model:show="showPicker"
                    destroy-on-close
                    round
                    position="bottom"
                  >
                    <picker
                      :model-value="selected_account.account_id"
                      show-toolbar
                      cancel-button-text="မလုပ်တော့ပါ"
                      confirm-button-text="အတည်ပြုမည်"
                      title="ဘဏ်အကောင့်ရွေးပါ"
                      :columns="columns"
                      @cancel="showPicker = false"
                      @confirm="onConfirm"
                    />
                  </popup>
                  <span class="text-red-500 text-xs mt-1">{{
                    errors.account
                  }}</span>
                </div>
              </div>
            </div>
            <div
              class="col-12 p-0 d-flex flex-wrap"
              v-if="account.length !== 0"
            >
              <div class="col-12 py-3">
                <span style="
                    color: #fff !important;
                    font-size: 1rem;
                    font-weight: 400 !important;
                  ">{{ account[0].name }}</span>
                <nav
                  class="side-nav my-2"
                  style="
                    border-radius: 0.5rem;
                    background: #000000;
                    border: 1px solid rgb(240 97 38 / 1);
                  "
                >
                  <div class="text-center py-2 pt-3">
                    <!-- <img @click="$router.push('/banking')" style="position: absolute; height: 2rem; right: 2.5rem;" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dc500777-e8e3-4267-ace1-cdcf5a215600/public" alt=""> -->
                    <!-- <h3 class="text-dark">{{ account[0].name }}</h3> -->
                    <span
                      class="text-white"
                      style="font-size: 1rem; font-weight: 400 !important"
                    >{{ account[0].account_name
                    }}</span>
                    <h3
                      class="text-muted py-2"
                      id="textToCopy"
                    >
                      {{ account[0].number }}
                    </h3>
                    <div class="mx-auto mb-2">
                      <span
                        class="text-dark badge badge-dark"
                        @click="copyText"
                      >Copy</span>
                    </div>
                  </div>
                </nav>

                <span
                  class="text-sm"
                  style="color: #000"
                >{{
                  account[0].note
                }}</span>
              </div>
            </div>
          </div>
          <!-- <hr class="my-4" /> -->
          <div class="my-3">
            <div class="row">
              <!-- <div class="col-lg-12">
                                  <div class="form-group">
                                      <label class="form-control-label" style="color: #000 !important;">{{$t('deposit.screenshot')}}</label>

                                      <div class="custom-file d-flex">
                                          <van-uploader
                                              class="mx-auto"
                                              v-model="imageUploader"
                                              :max-count="1"
                                          />
                                      </div>
                                      <span class="text-dark">{{
                                          errors.image
                                      }}</span>
                                  </div>
                              </div> -->
              <div class="col-lg-12">
                <div class="form-group">
                  <label
                    class="form-control-label"
                    for="input-email"
                    style="
                      color: #fff !important;
                      font-size: 1rem;
                      font-weight: 400 !important;
                    "
                  >{{ $t("deposit.amount") }}
                  </label>
                  <span
                    class="ml-2"
                    style="
                      color: #ccc;
                      font-size: 0.9rem;
                      font-weight: 500 !important;
                    "
                  >{{ $t("deposit.minimum_deposit") }}</span>
                  <input
                    type="number"
                    id="input-email"
                    class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                    v-model="depositData.amount"
                  />
                  <span class="text-red-500 text-xs mt-1">{{
                    errors.amount
                  }}</span>
                </div>
              </div>
              <div class="!grid w-full gap-3 !grid-cols-3">
                <div
                  @click="depositData.amount = 3000"
                  class="w-full bg-[#2b1c59] cursor-pointer text-[18px] text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  3000 ฿
                </div>
                <div
                  @click="depositData.amount = 5000"
                  class="w-full bg-[#2b1c59] text-[18px] cursor-pointer text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  5000 ฿
                </div>
                <div
                  @click="depositData.amount = 10000"
                  class="w-full bg-[#2b1c59] text-[18px] cursor-pointer text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  10,000 ฿
                </div>
                <div
                  @click="depositData.amount = 30000"
                  class="w-full bg-[#2b1c59] text-[18px] cursor-pointer text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  30,000 ฿
                </div>
                <div
                  @click="depositData.amount = 50000"
                  class="w-full bg-[#2b1c59] text-[18px] cursor-pointer text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  50,000 ฿
                </div>
                <div
                  @click="depositData.amount = 100000"
                  class="w-full bg-[#2b1c59] text-[18px] cursor-pointer text-white flex items-center justify-center py-4 rounded-xl"
                  style="color: hsla(0, 0%, 100%, 0.5)"
                >
                  100,000 ฿
                </div>
              </div>
            </div>
          </div>
          <div class="!mt-2">
            <div class="form-group">
              <label
                class="form-control-label"
                style="
                  color: #ccc;
                  font-size: 1rem;
                  font-weight: 400 !important;
                "
              >{{
                $store.state.language === "en"
                  ? "Last Transaction ID 6 digits"
                  : "လုပ်ငန်းစဉ်နံပါတ် (နောက်ဆုံး 6 လုံး)"
              }}</label>
              <input
                type="number"
                id="input-email"
                class="bg-transparent text-white border-0 !border-b-[1px] w-full py-3 !border-white rounded-0"
                v-model="depositData.remark"
              />
              <span class="text-success">{{ errors.remark }}</span>
            </div>
            <div class="form-group pt-3">
              <button
                type="button"
                class="bg-gradient-to-l text-white !text-[20px] from-[#924aff] to-[#4f3ffd] w-full !rounded-full py-3"
                style=""
                @click="sendDepositData()"
              >
                <div v-if="!isConfirm">
                  {{ $t("deposit.submit") }}
                </div>

                <Loading
                  color="#000000"
                  v-if="isConfirm"
                  size="24"
                  class="px-4 py-0"
                />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";
import AccountSelect from "./components/AccountSelect.vue";
import { Picker, Popup } from "vant";

export default {
  components: { AccountSelect, Loading, Picker, Popup },
  data() {
    return {
      selected_account: {},
      accounts: [],
      account: [],
      imageUploader: [],
      depositData: {
        amount: 0,
      },
      errors: {},
      isConfirm: false,
      error: null,
      showPicker: false,
      columns: [],
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    onConfirm(value) {
      this.showPicker = false;
      this.selected_account.account_id = value.value;
    },
    copyText() {
      // Get the text to copy
      const textToCopy = document.getElementById("textToCopy").innerText;

      // Create a temporary textarea element
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;

      // Append the textarea to the DOM
      document.body.appendChild(textarea);

      // Select the text in the textarea
      textarea.select();

      // Execute the 'copy' command
      document.execCommand("copy");

      // Remove the temporary textarea
      document.body.removeChild(textarea);

      alert("You have successfully copied!");
    },
    async fetchAccounts() {
      try {
        const res = await axios.get("/accounts", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.accounts = res.data.data;
        this.columns = this.accounts.map((acc) => ({
          text: acc.name,
          value: acc.id,
        }));
        // Group objects by name
        // const groupedByName = this.accounts.reduce((acc, obj) => {
        //     acc[obj.name] = acc[obj.name] || [];
        //     acc[obj.name].push(obj);
        //     return acc;
        // }, {});

        // // Get a random object from each group
        // const getRandomObjectFromGroup = (group) => {
        //     const randomIndex = Math.floor(Math.random() * group.length);
        //     return group[randomIndex];
        // };

        // // Collect the random objects into a single array
        // this.accounts = Object.keys(groupedByName).map(name => getRandomObjectFromGroup(groupedByName[name]));
      } catch (error) {
        console.log(error);
      }
    },
    async sendDepositData() {
      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account =
            this.$store.state.language === "en"
              ? "Please pick account type"
              : "အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။";
          return false;
        }
        // if (!this.imageUploader.length > 0) {
        //   this.errors.image = this.$store.state.language === 'en'
        //     ? 'Please insert screenshot photo'
        //     : 'ငွေပေးချေမူမှတ်တမ်း (screenshot) ထည့်သွင်းပါ။';
        //   return false;
        // }
        if (!this.depositData.amount) {
          this.errors.amount =
            this.$store.state.language === "en"
              ? "Please enter amount"
              : "ငွေပမာဏထည့်ပေးပါ။";
          return false;
        }
        if (!this.depositData.amount) {
          this.errors.amount =
            this.$store.state.language === "en"
              ? "Please enter amount"
              : "ငွေပမာဏထည့်ပေးပါ။";
          return false;
        }
        if (this.depositData.amount < 3000) {
          this.errors.amount =
            this.$store.state.language === "en"
              ? "Please enter at least 3,000 ฿"
              : "ငွေပမာဏအနည်းဆုံး 3,000 ထည့်ပေးပါ။";
          return false;
        }
        if (!this.depositData.remark || this.depositData.remark.length < 6) {
          this.errors.remark =
            this.$store.state.language === "en"
              ? "Please enter last transaction id 6"
              : "Please enter last transaction id 6";
          return false;
        }
        this.isConfirm = true;
        // if (this.imageUploader[0]) {
        //   this.depositData.transaction_image = this.imageUploader[0].content;
        // }
        this.depositData.account_id = this.account[0].id;
        this.depositData.date = this.currentTime;
        this.depositData.lang = localStorage.getItem("language");
        const res = await axios.post("/deposits", this.depositData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.imageUploader = [];
        this.depositData = {};
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.isConfirm = false;
      } catch (error) {
        Toast.fail(
          this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။"
        );
        this.error = error.response.data;
        this.isConfirm = false;
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require("moment-timezone");
      const dateInTimeZone = moment.tz(new Date(), "Asia/Rangoon");
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      // Create a new Date object with the extracted components
      const newDateObject = new Date(
        year,
        month,
        day,
        hour,
        minute,
        second,
        millisecond
      );
      return newDateObject;
    },
  },
  watch: {
    "selected_account.account_id": function () {
      this.account = this.accounts.filter(
        (account) => account.id === this.selected_account.account_id
      );
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format("lll");
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchAccounts();
    const authUser = await this.fetchUser();
    this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push("/auth/login");
    }
  },
};
</script>
<style scoped>
.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border: 1px solid black;
  border-radius: 8px;
  padding: 0px 15px;
  background: transparent;
  /* font-weight: bold; */
}

.custom-btn {
  background: #c7a241 !important;
  /* border: 1px solid #D79032 !important; */
  box-shadow: none !important;
  color: black !important;
  width: 100% !important;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  height: 40px !important;
}

.custom-input,
.custom-input:active,
.custom-input:focus {
  background: transparent !important;
  color: white !important;
  /* border-radius: 30px;
    border: 1px solid #a4a4a4 !important; */
  background-color: #000e22 !important;
  border: 1px solid #434f64 !important;
  border-radius: 0.5rem;
  text-align: center;
  /* height: 50px; */
  font-size: 1.3rem;
  font-weight: 300;
  box-shadow: none !important;
}

.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 10px;
  /* color: white; */
  /* background: linear-gradient(to top, #0ba360 0%, #3cba92 100%); */
  /* background: linear-gradient(-20deg, #00cdac 0%, #8ddad5 100%); */
  background: #000000 !important;
  border: 1px solid linear-gradient(180deg, #f7b733 -83.59%, #fc4a1a 96.87%) !important;
  justify-content: center;
}

.custom-file {
  height: auto;
}
</style>
